import { Injector } from "@angular/core";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodePharmaceuticalProduct } from "../Entity/TreeNodePharmaceuticalProduct";
import { TreeNodeDrugIngredientsList } from "./TreeNodeDrugIngredientsList";
import { TreeNodeDrugRouteList } from "./TreeNodeDrugRouteList";
import { TreeNodeMedicalDeviceList } from "./TreeNodeMedicalDeviceList";
import { TreeNodeOldDrugIngredientsList } from "./TreeNodeOldDrugIngredientsList";
import { ErrorType } from "../../ErrorType";
import { environment } from "../../../../../../environments/environment";

export class TreeNodePharmaceuticalProductsList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new ListView(),
        'Pharmaceutical Products ({param})'
      );
      this.parent = parent;
      this.labelNodeName = 'Parmaceutical Products';
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(): Art57Node[] | null {
      let node = new TreeNodePharmaceuticalProduct(this.ioc!, this);
  
      let art57NodesTemplate: Art57Node[] = [];
  
      art57NodesTemplate.push(new TreeNodeDrugRouteList(this.ioc!, node));
      art57NodesTemplate.push(new TreeNodeDrugIngredientsList(this.ioc!, node));
      art57NodesTemplate.push(new TreeNodeOldDrugIngredientsList(this.ioc!, node));
      art57NodesTemplate.push(new TreeNodeMedicalDeviceList(this.ioc!, node));
  
      art57NodesTemplate.map((nodeToAdd) => {
        node.children?.push(nodeToAdd);
      });
  
      this.children?.push(node);
  
      this.refreshLabel();
  
      return [node];
    }
  
    override validateBusinessRules(): any[] {
      let errors: any = [];
      if (!this.children || this.children.length == 0) {
        errors.push({
          node: this,
          errorID: this.key,
          errorType: ErrorType.bussinessValidationError,
          controlId: undefined,
          controlLabel: '',
          error: 'Section is Mandatory',
        });
      } else {
        errors.push({
          node: this,
          errorID: this.key,
          errorType: ErrorType.errorInactive,
          controlId: undefined,
          controlLabel: '',
          error: '',
        });
      }
  
      return errors;
    }
  
    override getMessage(): any {
      let pharmaceuticalproducts: Art57Node[] = [];
      this.children?.forEach((node) => {
        let pharmaceuticalproduct = node as Art57Node;
        pharmaceuticalproducts.push(pharmaceuticalproduct.getMessage());
      });
      if (pharmaceuticalproducts.length > 0) {
        return {
          pharmaceuticalproducts: {
            pharmaceuticalproduct: pharmaceuticalproducts,
          },
        };
      } else {
        return undefined;
      }
    }
  
    override getHeaders(): string[] {
      return ['EV Code', 'Pharmaceutical Product'];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodePharmaceuticalProductsList =
        new TreeNodePharmaceuticalProductsList(this.ioc!, newParent);
  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }
  }

